var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"deploy"}},[_c('index',[_c('el-breadcrumb',[_c('el-breadcrumb-item',[_vm._v("教务")]),_c('el-breadcrumb-item',{attrs:{"to":"/paike_index"}},[_vm._v("智能排课")]),_c('el-breadcrumb-item',[_c('a',{staticStyle:{"color":"#000000"}},[_vm._v("排课")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }